<script>
export default {
  name: "new-eye-icon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.3866 7.99999C10.3866 9.31999 9.31995 10.3867 7.99995 10.3867C6.67995 10.3867 5.61328 9.31999 5.61328 7.99999C5.61328 6.67999 6.67995 5.61333 7.99995 5.61333C9.31995 5.61333 10.3866 6.67999 10.3866 7.99999Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.9999 13.5133C10.3532 13.5133 12.5466 12.1267 14.0732 9.72666C14.6732 8.78666 14.6732 7.20666 14.0732 6.26666C12.5466 3.86666 10.3532 2.48 7.9999 2.48C5.64656 2.48 3.45323 3.86666 1.92656 6.26666C1.32656 7.20666 1.32656 8.78666 1.92656 9.72666C3.45323 12.1267 5.64656 13.5133 7.9999 13.5133Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
